import type { ReactNode } from "react";

import { Redirect } from "react-router-dom";

import { useAdvancedTradingDashboardAccess } from "~/v2/helpers/featureFlags";
import { Path } from "~/v2/path";

export const RequireAdvancedTradingDashboard = ({
  children,
}: {
  children: ReactNode;
}) => {
  const accessStatus = useAdvancedTradingDashboardAccess();

  if (accessStatus === "pending" || accessStatus === "unavailable") {
    return null;
  }
  if (accessStatus === "denied") {
    return <Redirect to={Path.ROUTE_DASHBOARD} />;
  }
  return <>{children}</>;
};
